import { GetShipmentInstructionsArgs } from 'types/api/arguments/get-shipment-instructions-args'
import { ShipmentInstructionsResponse } from 'types/api/response/shipment-instructions-response'

import { api } from './api'
import { moneyObjectHeader } from './money-object-header'

export const getShipmentInstructions = ({ transactionId }: GetShipmentInstructionsArgs) =>
  api.get<ShipmentInstructionsResponse>(`transactions/${transactionId}/shipment_instructions`, {
    headers: moneyObjectHeader,
  })
